













































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { sendChangeStatus } from '@/api/orders'
import { IChangeStatus } from '@/api/types'
import { OrderStatusEnum } from '@/api/enums'

@Component({
  name: 'changeStatus',
  components: {}
})
export default class extends Vue {
  @Prop({ default: false }) dialogVisible!: boolean;
  @Prop({ type: Object }) value!: IChangeStatus;

  private loading = false;
  private defaultChangeStatus: IChangeStatus = {
    orderId: 0,
    currentStatus: '',
    newStatus: null,
    message: null
  };

  changeStatusForm = Object.assign({}, this.defaultChangeStatus);
  options: Array<{ key: string, value: string }> = [];

  created() {
    this.changeStatusForm = Object.assign({}, this.value)
  }

  mounted() {
    this.fetchData()
  }

  fetchData() {
    for (const [propertyKey, propertyValue] of Object.entries(OrderStatusEnum)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue
      }
      this.options.push({
        key: propertyKey,
        value: OrderStatusEnum[propertyValue]
      })
    }
  }

  handleClose() {
    this.$emit('close', true)
  }

  async submitChangeStatus() {
    const frm = this.$refs.changeStatusForm as Form
    frm.validate(async(valid) => {
      if (valid) {
        this.loading = true
        console.log(
          `Sending Change Status for ${this.changeStatusForm.orderId} to ${this.changeStatusForm.newStatus} from ${this.changeStatusForm.currentStatus}.`
        )
        await sendChangeStatus(
          this.changeStatusForm.orderId,
          this.changeStatusForm.newStatus
        )
        this.changeStatusForm.newStatus = null
        this.$notify({
          title: 'Success',
          message: 'Status Changed succesfully.',
          type: 'success',
          duration: 4000
        })
        this.dialogVisible = false
        this.handleClose()
        return true
      }
    })
  }

  cancelForm() {
    this.dialogVisible = false
  }
}
